import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFall = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		opacity: .2,
		cx: 9,
		cy: 9,
		r: 8.25,
		fill: "#FF3B30"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.25 7.5C6.1 8.19929 9 10.5 9 10.5C9 10.5 12.0878 8.04477 12.75 7.5",
		stroke: "#FF3B30",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgFall);
export default ForwardRef;
